import { Box, styled } from "@mui/material";

export const StyledCrateList = styled(Box)(({ theme }) => ({
    width: "100%",
  ".addCrate": {
    border: `3px solid ${theme.contrast.main}`,
    width: "100%",
    borderRadius: "25px",
    padding: "1rem",
    display :"flex",
    boxSizing: "border-box",
    ".addbtn": {
        width: "35%",
        minHeight: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    ".buttongroup": {
        position:"relative",
        left: "0",
        width: "65%",
        gap: "1rem",
        display: "flex",
        flexWrap: "wrap",
        ".button": {
            padding: ".5rem 1rem",
            border: `2px solid ${theme.color.main}`,
            display: "flex",
            gap: "1rem",
            width: "fit-content",
            borderRadius: "25px",
            h4: {
                textTransform: "Capitalize"
            }
        }
    },
  },
}));
